module.exports = __webpack_public_path__ + "static/media/world.27127e30.png";